module.exports = "<div id=\"main-content-wrapper\" class=\"content-wrapper\" >\r\n<router-outlet></router-outlet>\r\n</div>"